module.exports = __webpack_public_path__ + "static/media/Group-16@3x.c95d8ef6.png";